<div class="ms-cell">
  <span *ngIf="label" class="ms-label">{{ label }}</span>

  <div class="ms-anchor">
    <button
      #trigger
      type="button"
      class="ms-trigger"
      [class.open]="open"
      [class.disabled]="disabled"
      [disabled]="disabled"
      [attr.aria-expanded]="open"
      (click)="toggleOpen()"
    >
      <span class="ms-summary">{{ summary }}</span>
      <span class="ms-caret">▾</span>
    </button>

    <div *ngIf="open" class="ms-panel">
      <div class="ms-panel-header">
        <input
          *ngIf="searchable"
          class="ms-search"
          type="text"
          [placeholder]="searchPlaceholder"
          [(ngModel)]="searchText"
        />
        <button type="button" class="ms-link-btn" (click)="selectAll()">All</button>
        <button type="button" class="ms-link-btn" (click)="selectNone()">None</button>
      </div>

      <div class="ms-list">
        <ng-container *ngFor="let group of groupedOptions(); trackBy: trackByGroup">
          <div *ngIf="group.group" class="ms-group-header">{{ group.group }}</div>
          <label
            *ngFor="let opt of group.items; trackBy: trackByValue"
            class="ms-row"
            [attr.for]="idPrefix + opt.value"
          >
            <input
              type="checkbox"
              [id]="idPrefix + opt.value"
              [checked]="isSelected(opt.value)"
              (change)="toggle(opt.value)"
            />
            <span class="ms-row-label">{{ opt.label }}</span>
          </label>
        </ng-container>
        <div *ngIf="filteredOptions().length === 0" class="ms-empty">
          No matches.
        </div>
      </div>
    </div>
  </div>
</div>
